import { type QueryOptions } from '@tanstack/query-core'

import { type ShipmentOrderInputHistoryDetailEntity } from '@/libs/api'

import { fetchShipmentOrderHistory } from '../api/fetch-shipment-order-history'
import { shipmentOrderHistoriesQueryKeys } from '../query-keys'

/**
 * 配送依頼履歴詳細のQueryOptionsを返す
 */
export const getShipmentOrderHistoryDetailQueryOption = (
  tenantKey: string,
  id: number
): Required<
  Pick<
    QueryOptions<ShipmentOrderInputHistoryDetailEntity>,
    'queryKey' | 'queryFn'
  >
> => {
  return {
    queryKey: shipmentOrderHistoriesQueryKeys.detail(tenantKey, id),
    queryFn: async ({ signal }) => {
      const { data } = await fetchShipmentOrderHistory(
        {
          tenantKey,
          id
        },
        signal
      )
      return data
    }
  }
}
